export default "__VITE_ASSET__Sq8Rp$dQ__"